import { render, staticRenderFns } from "./WorkListPage.vue?vue&type=template&id=5b53a052&"
import script from "./WorkListPage.vue?vue&type=script&lang=js&"
export * from "./WorkListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports